export const INDEX_CONSTS = {
  moduleName: 'epb-index',

  getters: {
    info: 'info',
    jobs: 'jobs'
  },
  actions: {
    fetchInfo: 'fetchInfo',
    listJobs: 'listJobs',
    readJob: 'readJob',
    submitJob: 'submitJob',
    reimportJob: 'reimportJob'
  },
  mutations: {
    setInfo: 'setInfo',
    setJobs: 'setJobs'
  }
};
